import { createFileRoute } from '@tanstack/react-router'
import { ContractsPage } from '../../../components/ContractsPage'

export const Route = createFileRoute('/$org/contracts/')({
  component: Contracts,
})

function Contracts() {
  return <ContractsPage />
}